var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{staticClass:"comrades",attrs:{"href":"https://comrades.dev","target":"_blank"}},[_c('FileIconComponent',{attrs:{"name":"comrades-logo"}}),_vm._m(0)],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"comrades-text"},[_c('span',{staticClass:"comrades-text__title"},[_vm._v("Разработано")]),_c('span',{staticClass:"comrades-text__subtitle"},[_vm._v("COMRADES DEVS")])])
}]

export { render, staticRenderFns }